<template>
  <section id="cloud_section" class="relative py-20 pb-48">
    <div
      class="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20"
      style="height: 80px; transform: translateZ(0px);"
    >
      <angled-s-v-g colorClass="text-white"></angled-s-v-g>
    </div>

    <div class="container mx-auto px-4">
      <div class="items-center flex flex-wrap">
        <div class="w-full md:w-4/12 ml-auto mr-auto px-4">
          <img
            alt="..."
            src="../assets/img/cloud.jpg"
            srcset="../assets/img/cloud_small.jpg 480w, ../assets/img/cloud.jpg 800w"
            sizes="(max-width: 600px) 480px, 800px"
            class="w-full align-middle rounded-lg shadow-lg"
          />
        </div>
        <div class="w-full md:w-5/12 ml-auto mr-auto px-4">
          <div class="md:pr-12">
            <div
              class="p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full"
            >
              <i class="fas fa-cloud text-xl"></i>
            </div>
            <h3 class="text-3xl font-semibold">Cloud Consulting</h3>
            <p class="mt-4 text-lg leading-relaxed text-gray-600">
              Wir begleiten Sie auf Ihrem Weg in die Cloud und erarbeiten für Sie eine auf Ihre Bedürfnisse angepasste Cloud-Strategie.
              Um Infrastrukturkosten zu senken und flexibler auf die individuellen Bedürfnisse und aktuellen Marktveränderungen reagieren zu können, zeigen wir verschiedene Lösungskonzepte auf.
              Mit unserem Know-How unterstützen wir Sie bei der Wahl des passenden Cloud-Anbieters, wir planen und implementieren für Sie die passende Cloud-Architektur.
            </p>
            <p class="pt-6">
              <a
                href="#contactForm"
                v-smooth-scroll
              >Erfahren Sie mehr über Ihre Zukunft in der Cloud und nehmen Sie unverbindlich mit uns Kontakt auf.</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AngledSVG from "../components/Base/AngledSVG.vue";
export default {
  components: {
    AngledSVG
  }
};
</script>

<style>
</style>